import React, { Component } from "react";
import Axios from "axios";
import daterangepicker from "daterangepicker"; // eslint-disable-line no-unused-vars
import ReactSelect from "react-select";
import $ from "jquery";
import moment from "moment";

// require("datatables.net-buttons")();
// require("datatables.net-buttons/js/buttons.colVis.js")();
// require("datatables.net-buttons/js/buttons.print.js")();
// require("datatables.net-buttons/js/buttons.html5.js")();

export class ReportUserSummary extends Component {
  constructor(props) {
    super(props);
    let top_this = this;
    this.state = {
      start_date_range: moment().subtract(1, "week").startOf("week").format("MM/DD/YYYY"),
      end_date_range: moment().subtract(1, "week").endOf("week").format("MM/DD/YYYY"),
      users: [],
      selected_users: [],
      times: [],
      times_computed_by_day: [],
      times_computed_by_item: [],
      times_computed_by_billing_status_category: [],
      dt_options: [
        {
          dom: "lfBrtip", //"lBfrtip",
          lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, "All"],
          ],
          order: [
            [0, "desc"],
            [1, "asc"],
            [2, "asc"],
          ],
          buttons: {
            buttons: ["print", "csv"],
            dom: {
              button: {
                className: "btn btn-info btn-sm m-1 mt-2",
              },
            },
          },
          footerCallback: function (row, data, start, end, display) {
            var api = this.api(),
              data; //eslint-disable-line no-redeclare
            let total = api
              .column(2)
              .data()
              .reduce(function (a, b) {
                return Number(a) + Number(b);
              }, 0);
            $(api.column(2).footer()).html(top_this.props.FormatNumberTwoDecimals(total));
          },
        },
        {
          dom: "lBfrtip", //"lBfrtip",
          lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, "All"],
          ],
          order: [
            [0, "desc"],
            [1, "asc"],
            [2, "asc"],
          ],
          buttons: {
            buttons: ["print", "csv"],
            dom: {
              button: {
                className: "btn btn-info btn-sm m-1 mt-2",
              },
            },
          },
          footerCallback: function (row, data, start, end, display) {
            var api = this.api(),
              data; //eslint-disable-line no-redeclare
            let total = api
              .column(2)
              .data()
              .reduce(function (a, b) {
                return Number(a) + Number(b);
              }, 0);
            $(api.column(2).footer()).html(top_this.props.FormatNumberTwoDecimals(total));
          },
        },
        {
          dom: "lfrtiBp", //"lBfrtip",
          lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, "All"],
          ],
          order: [
            [0, "desc"],
            [1, "asc"],
            [2, "asc"],
          ],
          buttons: {
            buttons: ["print", "csv"],
            dom: {
              button: {
                className: "btn btn-info btn-sm m-1 mt-2",
              },
            },
          },
          footerCallback: function (row, data, start, end, display) {
            var api = this.api(),
              data; //eslint-disable-line no-redeclare
            let total = api
              .column(2)
              .data()
              .reduce(function (a, b) {
                return Number(a) + Number(b);
              }, 0);
            $(api.column(2).footer()).html(top_this.props.FormatNumberTwoDecimals(total));
          },
        },
      ],
    };
  }
  componentDidMount() {
    this.GetUsers();
    $("#daterange-selector").daterangepicker({
      alwaysShowCalendars: true,
      opens: "left",
      autoApply: true,
      ranges: {
        Today: [moment(), moment()],
        "This Week": [moment().startOf("week"), moment()],
        "Last Week": [moment().subtract(1, "week").startOf("week"), moment().subtract(1, "week").endOf("week")],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [moment().subtract("1", "month").startOf("month"), moment().subtract("1", "month").endOf("month")],
        "This Year": [moment().startOf("year"), moment()],
      },
    });
    $("#daterange-selector").on("apply.daterangepicker", (e) => {
      window.$("#report-submit").click();
    });
  }
  GetUsers = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/user/get/all", {
      "x-access-token": this.props.authToken,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState(
            {
              users: response["data"]["users"],
              selected_users: [
                response.data.users
                  .map((m) => {
                    return { label: m.first_name + " " + m.last_name, value: m.id, current_user: m.current_user };
                  })
                  .find((l) => l.current_user === 1),
              ],
            },
            () => {
              this.GetTimeEntries();
            },
          );
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  GetTimeEntries = () => {
    if (this.state.selected_users.length === 0) {
      return;
    }
    let dataObj = {
      "x-access-token": this.props.authToken,
      user_id: this.state.selected_users.map((item) => item.value),
      daterange: $("#daterange-selector").val(),
    };
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/time-entries/get/by-user", dataObj)
      .then((response) => {
        if (response.data.status === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response.data.status === "success") {
          this.setState({ times: response.data.data }, () => {
            this.SetComputedValues();
          });
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };

  SetComputedValues = () => {
    console.log(this.state.times);
    // if ($.fn.DataTable.isDataTable("#datatables-chart-1")) $("#datatables-chart-1").DataTable().destroy();
    //       $("#datatables-chart-1").DataTable(this.state.dt_options[0]);

    //Compute Hours By Day
    this.ComputeHoursByDay();

    //Hours By Item
    this.ComputeHoursByItem();

    //Hours By Billing Status Category
    this.ComputeHoursByBillingStatusCategory();
  };
  ComputeHoursByDay = () => {
    let start = moment($("#daterange-selector").data("daterangepicker").startDate).startOf("day");
    let end = $("#daterange-selector").data("daterangepicker").endDate.startOf("day");
    let dates = [];
    for (let i = 0; i < start.isSameOrBefore(end); start.add(1, "days")) {
      dates.push(start.format("MM/DD/YYYY"));
    }
    let hours_per_day = [];
    for (let i = 0; i < dates.length; i++) {
      hours_per_day.push({
        date: dates[i],
        name: this.state.users.find((f) => f.id === this.state.selected_users[0].value).full_name,
        hours: this.state.times.filter((t) => moment(t.time_at).startOf("day").format("MM/DD/YYYY") === dates[i]).reduce((a, b) => a + b.hours, 0),
      });
    }
    if ($.fn.DataTable.isDataTable("#datatables-chart-1")) $("#datatables-chart-1").DataTable().destroy();
    this.setState({ times_computed_by_day: hours_per_day }, () => {
      //completed, remake datatable.
      $("#datatables-chart-1").DataTable(this.state.dt_options[0]);
    });
  };
  ComputeHoursByItem = () => {
    let items = [...new Set(this.state.times.map((item) => item.item_name))];
    let hours_per_item = [];
    for (let i = 0; i < items.length; i++) {
      hours_per_item.push({
        item: items[i],
        name: this.state.times[0].time_by,
        hours: this.state.times.filter((t) => t.item_name === items[i]).reduce((a, b) => a + b.hours, 0),
      });
    }
    if ($.fn.DataTable.isDataTable("#datatables-chart-2")) $("#datatables-chart-2").DataTable().destroy();
    this.setState({ times_computed_by_item: hours_per_item }, () => {
      //completed, remake datatable.
      $("#datatables-chart-2").DataTable(this.state.dt_options[1]);
    });
  };
  ComputeHoursByBillingStatusCategory = () => {
    let billing_statuses = [...new Set(this.state.times.map((item) => item.billing_status_category_name))];
    let hours_per_billing_status_category = [];
    for (let i = 0; i < billing_statuses.length; i++) {
      hours_per_billing_status_category.push({
        billing_status: billing_statuses[i],
        name: this.state.times[0].time_by,
        hours: this.state.times.filter((t) => t.billing_status_category_name === billing_statuses[i]).reduce((a, b) => a + b.hours, 0),
      });
    }
    if ($.fn.DataTable.isDataTable("#datatables-chart-3")) $("#datatables-chart-3").DataTable().destroy();
    this.setState({ times_computed_by_billing_status_category: hours_per_billing_status_category }, () => {
      //completed, remake datatable.
      $("#datatables-chart-3").DataTable(this.state.dt_options[2]);
    });
  };
  render() {
    return (
      <main className="content">
        <div className="container-fluid">
          <div className="header">
            {console.log(this.state)}
            <h1 className="header-title">User Overview</h1>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header row">
                  <div className="card-actions float-end">
                    {/* <a href="#" className="me-1">
                      <FontAwesomeIcon icon="sync" id="clients-list-refresh" onClick={this.GetItems} />
                    </a>
                    <a href="#" className="me-1">
                      <FontAwesomeIcon icon="plus" id="clients-list-refresh" onClick={this.PrepAddItem} />
                    </a> */}
                  </div>
                  <div className="col-md-12">
                    <h5 className="card-title mb-0">User Overview</h5>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-1">
                    <div className="col-sm-12 col-md-6 col-lg-3">
                      <ReactSelect
                        options={this.state.users
                          .sort((a, b) => {
                            return a.current_user < b.current_user;
                          })
                          .map((e) => {
                            return { label: e.first_name + " " + e.last_name, value: e.id };
                          })}
                        value={this.state.selected_users}
                        onChange={(e) => {
                          this.setState({ selected_users: [e] }, () => {
                            this.GetTimeEntries();
                          });
                        }}
                      />
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-3">
                      <input className="form-control" type="text" id="daterange-selector" defaultValue={this.state.start_date_range + " - " + this.state.end_date_range} />
                    </div>
                    <div className="col-sm-12 col-md-1 col-xl-1">
                      <button id="report-submit" className="btn btn-primary" onClick={this.GetTimeEntries}>
                        Submit
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-4">
                      <h4>Time By Day</h4>
                      <table id="datatables-chart-1" className="table table-striped" style={{ width: "100%" }}>
                        {/* Table header */}
                        <thead>
                          <tr>
                            <th>User</th>
                            <th>Date</th>
                            <th>Hours</th>
                          </tr>
                        </thead>
                        {/* Table body */}
                        <tbody id="clients-table-body">
                          {this.state.times_computed_by_day.map((time, i) => (
                            <tr key={time.date}>
                              <td>{time.name}</td>
                              <td>{time.date}</td>
                              <td className="text-right">{this.props.FormatNumberTwoDecimals(time.hours)}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr role="row">
                            <th></th>
                            <th></th>
                            <th className="text-right"></th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                    <div className="col-md-4">
                      <h4>Time By Item</h4>
                      <table id="datatables-chart-2" className="table table-striped" style={{ width: "100%" }}>
                        {/* Table header */}
                        <thead>
                          <tr>
                            <th>User</th>
                            <th>Item</th>
                            <th>Hours</th>
                          </tr>
                        </thead>
                        {/* Table body */}
                        <tbody id="clients-table-body">
                          {this.state.times_computed_by_item.map((time, i) => (
                            <tr key={time.item}>
                              <td>{time.name}</td>
                              <td>{time.item}</td>
                              <td className="text-right">{this.props.FormatNumberTwoDecimals(time.hours)}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr role="row">
                            <th></th>
                            <th></th>
                            <th className="text-right"></th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                    <div className="col-md-4">
                      <h4>Time By Billing Status Category</h4>
                      <table id="datatables-chart-3" className="table table-striped" style={{ width: "100%" }}>
                        {/* Table header */}
                        <thead>
                          <tr>
                            <th>User</th>
                            <th>Billing Status</th>
                            <th>Hours</th>
                          </tr>
                        </thead>
                        {/* Table body */}
                        <tbody id="clients-table-body">
                          {this.state.times_computed_by_billing_status_category.map((time, i) => (
                            <tr key={time.billing_status}>
                              <td>{time.name}</td>
                              <td>{time.billing_status}</td>
                              <td className="text-right">{this.props.FormatNumberTwoDecimals(time.hours)}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr role="row">
                            <th></th>
                            <th></th>
                            <th className="text-right"></th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default ReportUserSummary;
